module.exports = "/assets/c5978d8cfc0a8ce2373e33980dd34486.svg";